import { useGetContentListQuery } from '@api/api';
import { ContentRequest, EpiBlock } from '@api/types';
import { BrandSliderPlaceholder, GenericError, Image } from '@components';
import { Box, styled } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { A11y, Autoplay } from 'swiper';
import 'swiper/css/bundle';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useBrandSlider } from './brand-slider.hook';

export const BrandSliderWrapper = styled(Box)`
  width: 100%;
  & .swiper-wrapper {
    -webkit-transition-timing-function:linear!important;
    -o-transition-timing-function:linear!important;
    transition-timing-function:linear!important;
  }
  & img {
    ${breakpoints.down('sm')} {
      max-height: 140px;
    }
    max-height: 200px;
    object-fit: cover;
    width: 100%;
  }
}`;

export const BrandSlider = ({ references }: { references: number[] }) => {
  const { enableLoopAndAutoplay, dynamicSlidesPerView, sliderProps } = useBrandSlider(references);

  const request: ContentRequest = { references: references, epiEditMode: false, expand: '*' };
  const response = useGetContentListQuery(request);
  const { data, isLoading, isSuccess, isError } = response;

  if (isLoading) {
    return <BrandSliderPlaceholder references={references} />;
  }

  return (
    <BrandSliderWrapper>
      {isSuccess && data && (
        <Swiper
          modules={[Autoplay, A11y]}
          key={`${enableLoopAndAutoplay}-${dynamicSlidesPerView}`}
          {...sliderProps}
        >
          {data?.map((item: EpiBlock) => {
            return (
              <SwiperSlide key={item.contentLink?.id}>
                <Image image={item?.contentLink?.url} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
      {isError && <GenericError />}
    </BrandSliderWrapper>
  );
};
